import * as Yup from 'yup';

/**
 * Validation schema for creating a new manual TS plus license.
 * @constant
 * @type {object}
 * @property {Yup.StringSchema} license
 * @property {Yup.StringSchema} officeName
 * @property {Yup.NumberSchema} numOfUsers
 * @property {Yup.StringSchema} computerDetails
 * @property {Yup.DateSchema} startDate
 * @property {Yup.DateSchema} expireDate
 */
const createManualLicenseValidation = Yup.object({
    license: Yup.string()
        .required('Required')
        .trim('Remove any leading or trailing spaces')
        .uppercase(),
    numOfUsers: Yup.number().required('Required').integer().positive(),
    createDate: Yup.date().required('Required'),
    errorFlag: Yup.boolean().default(false),
    officeId: Yup.string()
        .transform((v, ov) => (ov === '' ? null : v))
        .nullable(),

    officeName: Yup.string()
        .transform((v, ov) => {
            if (ov === '' || ov == null) return null;
            return String(ov).trim().toUpperCase();
        })
        .nullable(),

    _officeGuard: Yup.mixed().test(
        'office-required',
        'Either Office ID or Office Name is required',
        function () {
            const { officeId, officeName } = this.parent;
            return !!(officeId || officeName);
        }
    )
});

export default createManualLicenseValidation;
